import { CommonDataService } from './../../appDataServices/commonDataService';
import { CommonService } from './../../_services/common.service';
import { StringConstants } from './../../_constants/stringConstants';
import { StorageService } from './../../_services/storage.service';
import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-switch-language',
  templateUrl: './switch-language.component.html',
  styleUrls: ['./switch-language.component.scss'],
})
export class SwitchLanguageComponent implements OnInit {

  @Input() options: any = {}
  formSubmitted = false;
  loading = false;
  currentLanguage = 'en';
  languages = [];
  constructor(
    private modal: PopoverController,
    private storage: StorageService,
    private commonService: CommonService,
    private commonDataService: CommonDataService,
    private translate: TranslateService
  ) { }

  ngOnInit() {

    this.storage.get(StringConstants.CURRENT_Language).then(lang => {
      if (lang !== null && lang !== undefined && lang !== '') {
        this.currentLanguage = lang;
      }
    });
    this.getSupportedLanguages();
  }

  close(returnVal = false) {
    this.modal.dismiss(returnVal);
  }

  onLanguageSwitch(language: string) {
    this.storage.add(StringConstants.CURRENT_Language, language).then(res => {
    this.translate.setDefaultLang(language);
    this.translate.use(language);
    this.close(true);
    });

  }
  getSupportedLanguages() {
    this.commonService.getSupportedLanguages().then((languages: any[]) => {

      if (Array.isArray(languages) && languages.length > 0) {
        this.languages = languages;
      } else {
        this.commonDataService.getSupportedLanguages().subscribe(langs => {
          if (langs !== null && langs !== undefined) {
            this.languages = langs;
            this.commonService.storeSupportedLanguages(langs);
          }
        });
      }
    });
  }

}
